export const isSsoEnabled = () => process.env.REACT_APP_DISABLE_SSO !== 'true';

export const isChinaRegion = () => process.env.REACT_APP_REGION === 'CHINA';

export const isRSScreenDetectionEnabled = () =>
  process.env.REACT_APP_ENABLE_ROOM_SCAN_SCREEN_DETECTION === 'true';

export const isSingleNameEnabled = () => process.env.REACT_APP_ENABLE_SINGLE_NAME === 'true';

export const isSecurityProfileEnabled = () =>
  process.env.REACT_APP_ENABLE_SECURITY_PROFILES === 'true';
